module.exports = __webpack_public_path__ + "static/media/COVID safety video script_1632332575655.a8bc6598.docx";